import { render } from "./ProcessorDialog.vue?vue&type=template&id=129c0e0a&scoped=true"
import script from "./ProcessorDialog.vue?vue&type=script&lang=ts"
export * from "./ProcessorDialog.vue?vue&type=script&lang=ts"

import "./ProcessorDialog.vue?vue&type=style&index=0&id=129c0e0a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-129c0e0a"

export default script
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QDialog});
